import React from "react";
import Icon from "../AppIcon";
import Button from "./Button";

interface ConfirmationModalProps {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
	title: string;
	message: React.ReactNode;
	confirmButtonText?: string;
	cancelButtonText?: string;
	isDestructive?: boolean;
	isLoading?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
	isOpen,
	onClose,
	onConfirm,
	title,
	message,
	confirmButtonText = "Confirm",
	cancelButtonText = "Cancel",
	isDestructive = false,
	isLoading = false,
}) => {
	if (!isOpen) return null;

	const handleConfirm = () => {
		onConfirm();
	};

	return (
		<div className="fixed inset-0 bg-black/50 flex items-center justify-center z-1200 p-4">
			<div className="bg-card border border-border rounded-lg w-full max-w-md modal-shadow">
				{/* Header */}
				<div className="p-6 border-b border-border">
					<div className="flex items-center space-x-3">
						<div
							className={`p-2 rounded-full ${
								isDestructive
									? "bg-error/10 text-error"
									: "bg-warning/10 text-warning"
							}`}
						>
							<Icon
								name={isDestructive ? "AlertTriangle" : "AlertCircle"}
								size={24}
							/>
						</div>
						<h2 className="text-xl font-semibold text-foreground">{title}</h2>
					</div>
				</div>

				{/* Content */}
				<div className="p-6">
					{typeof message === "string" ? (
						<p className="text-foreground">{message}</p>
					) : (
						<div className="text-foreground">{message}</div>
					)}
				</div>

				{/* Footer */}
				<div className="p-6 border-t border-border flex items-center justify-end space-x-3">
					<Button
						type="button"
						variant="outline"
						onClick={onClose}
						disabled={isLoading}
					>
						{cancelButtonText}
					</Button>
					<Button
						type="button"
						variant={isDestructive ? "destructive" : "default"}
						onClick={handleConfirm}
						disabled={isLoading}
					>
						{isLoading ? (
							<>
								<Icon name="Loader2" size={16} className="mr-2 animate-spin" />
								Processing...
							</>
						) : (
							confirmButtonText
						)}
					</Button>
				</div>
			</div>
		</div>
	);
};

export default ConfirmationModal;
